<template>
    <div>
        <table class="table">
            <tbody>
                <tr>
                    <td class="border-right pr-5">
                        <div class="row mt-3">
                            <div class="col-md-6 col-sm-12">
                                <div class="form-group">
                                    <label class="form-label">{{$t('subMenu.salon_menu_service')}}</label>
                                    <div class="input-group bg-white shadow-inset-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-transparent border-right-0">
                                                <i class="fas fa-user-cog"></i>
                                            </span>
                                        </div>
                                        <input class="form-control pl-3" :placeholder="$t('subMenu.salon_menu_service')" v-model="selectedService[rowID]" required="" @click="show = !show">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <div class="form-group">
                                    <label class="form-label text-muted">{{$t('label.selling_price')}}</label>
                                    <div class="input-group bg-white shadow-inset-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-transparent border-right-0">
                                                <i class="fas fa-dollar-sign"></i>
                                            </span>
                                        </div>
                                        <input type="text" class="form-control" disabled="" v-model="sellingPrice[rowID]">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3 mb-4">
                            <div class="col">
                                <div class="form-group">
                                    <label class="form-label">{{$t('label.unit_price')}}</label>
                                    <div class="input-group bg-white shadow-inset-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-transparent border-right-0">
                                                <i class="fas fa-dollar-sign"></i>
                                            </span>
                                        </div>
                                        <input class="form-control service_row_num" type="number" step="any"
                                            :min="unitPrice[rowID]" 
                                            v-model="unitPrice[rowID]" 
                                            @change="calculateTotalByUnitPrice" 
                                            @keypress="isNumber($event)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label class="form-label">{{$t('label.quantity')}}</label>
                                    <div class="input-group bg-white shadow-inset-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-transparent border-right-0">
                                                <i class="fas fa-cart-plus"></i>
                                            </span>
                                        </div>
                                        <input class="form-control service_row_num" type="number" 
                                            :min="minQuantity" 
                                            v-model="quantity[rowID]" 
                                            @change="calculateTotalByQuantity" 
                                            @keypress="isNumber($event)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label class="form-label">Total</label>
                                    <div class="input-group bg-white shadow-inset-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-transparent border-right-0">
                                                <i class="fas fa-dollar-sign"></i>
                                            </span>
                                        </div>
                                        <input class="form-control service_row_num" type="number" step="any"
                                            :min="initialUnit" 
                                            v-model="total[rowID]" 
                                            @change="updateUnitPriceByTotal"
                                            @keypress="isNumber($event)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" :id="'serSwitch_' + rowID" v-model="autoExpiry[rowID]">
                                <label class="custom-control-label" :for="'serSwitch_' + rowID">{{$t('label.expiry')}}</label>
                            </div>
                        </div>
                        <p v-if="Object.keys(serviceItems).length != 0 && !isEnable[rowID]" class="error-validation">{{$t('message.error.disabled_item')}}</p>
                    </td>
                </tr>
            </tbody>
        </table>
        <div :class="{'show': show }" class="modal fade">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title">{{$t('header.list_of', {'item': $t('subMenu.salon_menu_service')})}}</h5>
                        <button type="button" class="close" @click="show = !show">
                            <span><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-5">
                            <div class="col-md-12 col-sm-12">
                                <div class="dataTables_filter mb-2">
                                    <label class="d-flex mb-0">
                                        <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchService" @keypress.enter="searchServiceItem">
                                        <button type="button" class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0" @click="searchServiceItem()">
                                            <i class="fas fa-search"></i>
                                        </button>
                                    </label>
                                </div>
                                <a class="link text-primary" @click="clearFilter()">{{$t('button_link.clear_filter')}}</a>
                            </div>
                        </div>
                        <ul class="nav nav-tabs mb-3" role="tablist">
                            <li class="nav-item border-bottom" v-for="c in serviceCategory" :key="c.id">
                                <a :class="{'active': selServiceCat[rowID] == c.id}" class="nav-link" role="tab" @click="filterCategory(c.id)">{{c.text}}</a>
                            </li>
                        </ul>
                        <div class="demo">
                            <button v-for="s in services" :key="s.itemID" type="button" class="btn btn-lg btn-outline-primary waves-effect waves-themed text-left fs-md" @click="selectItem(s.itemID)">
                                <span class="d-block">{{s.title}}</span>
                                <span class="d-block border-top pt-1 mt-1"><i class="fas fa-tag mr-2"></i>{{getCategoryText(s.category)}}</span>
                                <span class="d-block border-top pt-1 mt-1"><i class="fas fa-dollar-sign mr-3"></i>{{formatPrice(s.price)}} {{$t('label.ea')}}</span>
                            </button>
                            <div class="panel-tag mt-3" v-if="services.length == 0">{{$t('table.no_records')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {isNumber, formatPrice, calculateTotal} from './../../../../assets/js/dashboard/utilities'
import {handleSessionExpired, getCategoryText} from './../../../../assets/js/dashboard/dashboard'
export default {
    name:'packageItemService',
    props:{
        rowID: { type: Number },
        serviceItems: { type: Object }
    },
    data(){
        let itm = {};
        if(this.serviceItems != undefined){
            itm = Object.assign({}, this.serviceItems);
        }
        return{
            type: 'service',
            show: false, searchService: "",
            categoryList: "",
            serviceCategory: [], serviceItem: itm,
            selCat: "all",
            services: [],
            minQuantity: 1, initialUnit: 0,
            packageServiceItem:{},
        }
    }, 
    watch:{
        "$i18n.locale"(val){
            this.setCategory()
        }
    },
    computed:{
        selServiceCat(){
            var ret = {}
            if(this.serviceItems != undefined){
                if(Object.keys(this.serviceItems).length != 0){
                    for(var i=0; i<this.services.length; i++){
                        if(this.serviceItems.itemID == this.services[i].itemID){
                            ret[this.rowID] = this.services[i].category;
                            break;
                        }
                    }
                }else {
                    ret[this.rowID] = "all";
                }
            }
            return ret;
        },
        selectedServiceItemID(){
            var ret = {};
            if(this.serviceItems != undefined){
                ret[this.rowID] = Object.keys(this.serviceItems).length != 0 ? this.serviceItems.itemID : 0;
            }
            return ret;
        },
        selectedServiceTitle(){
            var ret = {};
            if(this.serviceItems != undefined){
                ret[this.rowID] = Object.keys(this.serviceItems).length != 0 ? this.serviceItems.title : "";
            }
            return ret;
        },
        selectedService(){
            var ret = {};
            if(this.serviceItems != undefined){
                ret[this.rowID] = Object.keys(this.serviceItems).length != 0 ? this.serviceItems.title + " [ " + this.serviceItems.unitPrice + " ]/ea." : "";
            }
            return ret;
        },
        unitPrice(){
            var ret = {};
            if(this.serviceItems != undefined){
                ret[this.rowID] = Object.keys(this.serviceItems).length != 0 ? this.serviceItems.unitPrice : 0;
            }
            return ret;
        },
        quantity(){
            var ret = {};
            if(this.serviceItems != undefined){
                ret[this.rowID] = Object.keys(this.serviceItems).length != 0 ? this.serviceItems.quantity : 0;
            }
            return ret;
        },
        total(){
            var ret = {};
            if(this.serviceItems != undefined){
                ret[this.rowID] = Object.keys(this.serviceItems).length != 0 ? this.serviceItems.quantity * this.serviceItems.unitPrice: 0;
            }
            return ret;
        },
        sellingPrice(){
            var ret = {}
            if(this.serviceItems != undefined){
                if(Object.keys(this.serviceItems).length != 0){
                    for(var i=0; i<this.services.length; i++){
                        if(this.serviceItems.itemID == this.services[i].itemID){
                            ret[this.rowID] = this.services[i].price;
                            break;
                        }
                    }
                }else {
                    ret[this.rowID] = 0;
                }
            }
            return ret;
        },
        autoExpiry(){
            var ret = {};
            if(this.serviceItems != undefined){
                ret[this.rowID] = Object.keys(this.serviceItems).length != 0 ? this.serviceItems.autoExpiry : 0;
            }
            return ret;
        },
        isEnable(){
            var ret = {};
            if(this.serviceItems != undefined){
                if(Object.keys(this.serviceItems).length != 0 ){
                    ret[this.rowID] = this.serviceItems.isEnable != undefined ? false : true
                }else{
                    ret[this.rowID] = false
                }
            }
            return ret;
        },
    },
    methods:{
        isNumber(e){
            return isNumber(e);
        },
        formatPrice(price){
            return formatPrice(price);
        },
        getCategoryText(id){
            return getCategoryText(id, this.serviceCategory)
        },
        clearFilter(){
            this.searchService = "";
            this.filterCategory("all");
        },
        searchServiceItem(){
            this.selCat = "all";
            var strFilter =  this.searchService == "" ? "" : "&search=" + this.searchService;
            this.getServiceItem(strFilter);
        },
        filterCategory(id){
            this.searchService = "";
            this.selCat = id;
            var strFilter = this.selCat == "all" ? "" : "&category=" + this.selCat;
            this.getServiceItem(strFilter);
        },
        selectItem(id){
            for(var i=0; i<this.services.length; i++){
                if(id == this.services[i].itemID){
                    this.selectedServiceItemID[this.rowID] = id;
                    this.selectedServiceTitle[this.rowID] = this.services[i].title;
                    this.selectedService[this.rowID] = this.selectedServiceTitle[this.rowID] + " [ " + this.services[i].price + " ]/ea.";
                    this.sellingPrice[this.rowID] = formatPrice(this.services[i].price);
                    this.unitPrice[this.rowID] = this.services[i].price
                    this.quantity[this.rowID] = 1
                    this.total[this.rowID] = calculateTotal(this.unitPrice[this.rowID], 1);
                    this.isEnable[this.rowID] = this.services[i].isEnable == 1 ? true : false
                    break;
                }
            }
            this.show = false;
            this.selServiceCat[this.rowID] = this.selCat;
        },
        calculateTotalByQuantity(e){
            this.quantity[this.rowID] = e.target.value
            this.total[this.rowID] = calculateTotal(this.unitPrice[this.rowID], this.quantity[this.rowID]);
            this.setTotal();
        },
        calculateTotalByUnitPrice(e){
            this.unitPrice[this.rowID] = e.target.value
            this.total[this.rowID] = calculateTotal(this.unitPrice[this.rowID], this.quantity[this.rowID]);
            this.setTotal();
        },
        updateUnitPriceByTotal(e){
            this.total[this.rowID] = e.target.value;
            this.unitPrice[this.rowID] = this.total[this.rowID] / this.quantity[this.rowID]

            var row = document.getElementById('serviceRow_' + this.rowID);
            if(row != null){
                var input = row.getElementsByClassName('service_row_num')
                input[0].value = this.unitPrice[this.rowID]
            }
        },
        setTotal(){
            var row = document.getElementById('serviceRow_' + this.rowID);
            if(row != null){
                var input = row.getElementsByClassName('service_row_num')
                input[2].value = this.total[this.rowID];
            }
        },
        getPackageServiceItem(){
            this.packageServiceItem["itemID"] = this.selectedServiceItemID[this.rowID];
            this.packageServiceItem["itemTitle"] = this.selectedServiceTitle[this.rowID];
            this.packageServiceItem["quantity"] = this.quantity[this.rowID];
            this.packageServiceItem["autoExpiry"] = this.autoExpiry[this.rowID] ? 1 : 0;
            this.packageServiceItem["unitPrice"] = this.unitPrice[this.rowID];

            return this.packageServiceItem;
        },
        getServiceItem(strFilter){
            let $vm = this;
            let QUERY_STRING =  "?type=" + this.type + strFilter
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.services = response.data.items;
                $vm.selServiceCat[$vm.rowID] = $vm.selCat;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        setCategory(){
            this.categoryList = JSON.parse(this.$store.state.category);
            this.serviceCategory.push({id: "all", text: this.$i18n.t('label.category')});
            for(var i=0; i<this.categoryList.service.length; i++){
                this.serviceCategory.push({id: i, text: this.categoryList.service[i]});
            }
        },
    },
    mounted(){
        let $vm = this;
        $vm.unitPrice[$vm.rowID] = Object.keys($vm.serviceItem).length != 0 ? $vm.serviceItem.unitPrice : 0;
        $vm.quantity[$vm.rowID] = Object.keys($vm.serviceItem).length != 0 ? $vm.serviceItem.quantity : 1;
        $vm.total[$vm.rowID] = Object.keys($vm.serviceItem).length != 0 ? $vm.serviceItem.unitPrice * $vm.serviceItem.quantity : 0;
        $vm.initialUnit = $vm.unitPrice[$vm.rowID];

        $vm.setCategory()
        $vm.getServiceItem("")
    }
}
</script>

<style scoped>
.show{ 
    display: block;
}

.nav-link{
    cursor: pointer;
}

.modal-body{
    height: 80vh;
    overflow-y: auto;
}
.error-validation{
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>